<template>
  <v-container
    v-if="items.length"
    class="tabs-content__container"
  >
    <component
      v-if="currentDialog"
      :is="currentDialog"
      @clearCurrentDialog="clearCurrentDialog"
    />
    <v-row margin="0">
      <v-col cols="12">
        <h1>Setup Checklist</h1>
      </v-col>
      <v-col
        cols="12"
        :class="!selectedTask ? 'col-md-11' : 'col-md-7'"
      >
        <v-card tile>
          <setup-checklist-items-list
            v-for="(item, index) in items"
            :key="index"
            :item="item"
            @toggleTaskSelected="toggleTaskSelected"
            @toggleItem="toggleItem"
          />
        </v-card>
      </v-col>
      <v-col cols="12" md="5">
        <setup-checklist-selected-item
          v-if="selectedTask"
          :task="selectedTask"
          @clearSelectedTask="clearSelectedTask"
          @setCurrentDialog="setCurrentDialog"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import lodash from 'lodash'
  import SetupChecklistItemsList from './SetupChecklistItemsList'
  import SetupChecklistSelectedItem from './SetupChecklistSelectedItem'
  import helpers from '../../helpers/functions'
  import SetupChecklistDialogSix from './dialogs/SetupChecklistDialogSix'

  export default {
    name: 'GettingStartedIndex',
    components: {
      SetupChecklistItemsList,
      SetupChecklistSelectedItem,
      SetupChecklistDialogSix
    },
    data () {
      return {
        currentDialog: null
      }
    },
    computed: {
      selectedAdvertiser () {
        const user = this.$store.getters.getCurrentUser
        return user ? user.firebaseAccount.selectedAdvertiser : null
      },
      items () {
        const setupMode = this.$store.getters.getSetupMode
        return setupMode ? setupMode.items : []
      },
      selectedTask () {
        if (!this.items.length) return false
        const taskId = this.$route.params.id
        return this.items.map(item => item.tasks)
          .reduce((a, b) => [...a, ...b], [])
          .find(task => Number(task.id) === Number(taskId))
      },
      selectedTaskMode () {
        if (this.$route.name === 'SetupChecklistSelectedTask') {
          return !!this.selectedTask
        }
        return true
      }
    },
    methods: {
      toggleTaskSelected (task) {
        const id = this.selectedAdvertiser
        const advertiser = lodash.cloneDeep(helpers.getAdvertiserById(id))
        let item = advertiser.setupMode.items.map(item => item.tasks)
          .reduce((a, b) => [...a, ...b], [])
          .find(t => t.id === task.id)
        if (item) item.completed = !item.completed
        this.$store.dispatch('updateAdvertiser', {id, data: advertiser})
      },
      toggleItem (itemName) {
        const id = this.selectedAdvertiser
        const advertiser = lodash.cloneDeep(helpers.getAdvertiserById(id))
        const item = advertiser.setupMode.items.find(i => i.name === itemName)
        if (item) item.opened = !item.opened
        this.$store.dispatch('updateAdvertiser', {id, data: advertiser})
      },
      clearSelectedTask () {
        this.selectedTask = null
      },
      setCurrentDialog (dialog) {
        this.currentDialog = dialog
      },
      clearCurrentDialog () {
        this.currentDialog = null
      }
    }
  }
</script>
